var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionInvoicing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_ac8b1b232e6c8cbfd5f460d560a855c418426257cb423842f7a54382a9831e18",
    gradientUnits: "userSpaceOnUse",
    x1: -6210.286,
    y1: -3.277,
    x2: -6209.286,
    y2: -3.277
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M47.71 92.16v40.32h63.63V29.77L47.71 51.59v40.57zM111.69 56.76l24.82-5.74 14.59 6.71v-9.1l-39.49-18.78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M118.74 63.06l17.76-4.14 24.83 11.74V85.8l-24.32-8.29-.23 41.35 24.56 2.15-.12 11.47H118.84l-.1-69.42z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M143.26 87.39v25.32l15.68 1.61V92.1l-15.68-4.71zM151.55 90.67v22.04M158.94 103.61l-15.68-3.25M62.18 84.02h34.7v34.7h-34.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M94.54 85.8L79.52 97.16 64.5 85.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionInvoicing);
export default __webpack_public_path__ + "static/media/subscriptionInvoicing.391e7c776728ec782a2274275d6424e0.svg";
export { ForwardRef as ReactComponent };